// removed by extract-text-webpack-plugin
module.exports = {"ProductSearchbar":"wmf-3YdPn-XK","ProductSearchbarDrawer":"wmf-2yAOQYiu","searchWrap":"wmf-indlX72F","listWrap":"wmf-3sMdnUKz"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/udeskSide/components/ProductSearchbar.module.less
// module id = 957
// module chunks = 0